
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import Leaders from './Aboutus/Leadership'
import { Link } from 'react-router-dom';

const AboutUs = () => {
  const teamMembers = [ 
    {
      name: "Indonesian Team",
      role: "Employee",
      image: "https://ik.imagekit.io/satfy9rkc/shared%20image%20(4).jpeg?updatedAt=1760508688725"
    },
    {
      name: "Indonesian Team",
      role: "Project Manager",
      image: "https://ik.imagekit.io/satfy9rkc/shared%20image%20(5).jpeg?updatedAt=1760508688885"
    },
  ];

  const clients = [
    { id: 1, name: "GS Battery", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/gs_battery.jpg?updatedAt=1759295406843" },
    { id: 2, name: "CRP Group", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/crp_group.png?updatedAt=1759295406585" },
    { id: 3, name: "HamiltonJet", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/HamiltonJet.jpg?updatedAt=1759295406583" },
    { id: 4, name: "Chiyaboon", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/chaiyaboon.png?updatedAt=1759295406531" },
    { id: 5, name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },
    { id: 6, name: "Vandewiele Savio", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/vandewiele_savio.jpg?updatedAt=1759295405536" },
    { id: 7, name: "GS Battery", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/gs_battery.jpg?updatedAt=1759295406843" },
    { id: 8, name: "CRP Group", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/crp_group.png?updatedAt=1759295406585" },
    { id: 9, name: "HamiltonJet", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/HamiltonJet.jpg?updatedAt=1759295406583" },
    { id: 10, name: "Chiyaboon", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/chaiyaboon.png?updatedAt=1759295406531" },
    { id: 11, name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },
    { id: 12, name: "Vandewiele Savio", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/vandewiele_savio.jpg?updatedAt=1759295405536" },

  ];


  const sampleClients = [
    { name: "GS Battery", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/gs_battery.jpg?updatedAt=1759295406843" },
    { name: "CRP Group", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/crp_group.png?updatedAt=1759295406585" },
    { name: "HamiltonJet", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/HamiltonJet.jpg?updatedAt=1759295406583" },
    { name: "Chiyaboon", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/chaiyaboon.png?updatedAt=1759295406531" },
    { name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },
    { name: "Vandewiele Savio", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/vandewiele_savio.jpg?updatedAt=1759295405536" },
    { name: "Dreem", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/dreem.jpg?updatedAt=1759295405197" },

    { name: "CMR", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/CMR.jpg?updatedAt=1759295406841" },
    { name: "SANDEN", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/sanden.png?updatedAt=1759295406829" },
    { name: "SANOH", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/sanoh.png?updatedAt=1759295406876" },
    { name: "AWAL GULF", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/awal_gulf.jpg?updatedAt=1759295406865" },

    { name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },

  ];

  const partners = [
    { id: 1, name: "NTT Data", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/nttdata_logo.jpg?updatedAt=1759295406563" },
    { id: 2, name: "Godland", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/godlan.jpg?updatedAt=1759295406816" },
    { id: 3, name: "Com Activity", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/ComActivity-Logo.jpg?updatedAt=1759295406889" },
    { id: 4, name: "Ioco", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/ioco.png?updatedAt=1759295406659" },
    { id: 5, name: "TCS", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/tata_group.png?updatedAt=1759295406633" },
    { id: 6, name: "BS Solutions", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/bs_solutions.png?updatedAt=1759295406543" },
    { id: 7, name: "columbus", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/columbus.png?updatedAt=1759295406545" },
    { id: 8, name: "Infoplot", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/infoplot_logo.jpg?updatedAt=1759295406499" },
    { id: 9, name: "mashfrog", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/mashfrog.png?updatedAt=1759295406486" },
    { id: 10, name: "sns", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/sns.png?updatedAt=1759295406511" },
    { id: 11, name: "Geniex", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/geniex.jpg?updatedAt=1759295406425" },
    { id: 12, name: "phitomas", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/phitomas.png?updatedAt=1759295405563" },
    { id: 14, name: "oneNeck", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder2/one_neck.jpg?updatedAt=1759295405537" },

  ];

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const stagger = {
    visible: { transition: { staggerChildren: 0.1 } }
  };

  return (
    <div className="bg-white">
      {/* Hero Video Section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="w-full h-auto relative overflow-hidden"
      >
        <video 
          src="https://ik.imagekit.io/kqumni8l2/logo%20reveal%20/ptkcs%20logo%202_4.mp4?updatedAt=1746009125412"
          className="w-full h-auto object-cover" 
          preload="metadata"
          autoPlay
          muted
          playsInline
        >
          Your browser does not support the video tag.
        </video>
      </motion.div>

      {/* Story Section */}
      <section className="py-10 md:py-10 px-4 sm:px-6 lg:px-8" style={{ background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)' }}>
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={stagger}
            className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center"
          >
            {/* Content */}
            <motion.div variants={fadeInUp} className="space-y-8">
              <div
                className="p-8 md:p-10 rounded-2xl shadow-lg"
                style={{ backgroundColor: '#FFFFFF', borderLeft: '6px solid #FF9800' }}
              >
                <h2 className="text-2xl md:text-2xl font-bold mb-6" style={{ color: '#1E293B' }}>Our Story</h2>
              
                <p     style={{
    color: '#272828',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    hyphens: 'none',
    whiteSpace: 'normal'
  }} className="text-base md:text-lg leading-relaxed" >
                  KCS Technologies is a forward-thinking technology firm that helps businesses revolutionize the way they operate and engage with customers. We use the power of technology to deliver mission critical IT services across the Enterprise Technology Stack to drive business impact. Kapil Technologies is an employer of choice with strong values, and fosters a culture of inclusion, belonging and corporate citizenship. 8-plus countries are entrusted by our customers to deliver what matters most.
                </p>
              </div>

            </motion.div>

            {/* Images */}
            <motion.div variants={fadeInUp} className="relative">
              <div className="grid grid-cols-2 gap-6">
                <motion.div
                  whileHover={{ y: -10 }}
                  className="relative"
                >
                  <img
                    src={teamMembers[0].image}
                    alt="Team Member 1"
                    className="rounded-2xl shadow-lg w-full h-56 md:h-64 object-cover"
                  />
                </motion.div>
                <motion.div
                  whileHover={{ y: -10 }}
                  className="relative mt-8"
                >
                  <img
                    src={teamMembers[1].image}
                    alt="Team Member 2"
                    className="rounded-2xl shadow-lg w-full h-56 md:h-64 object-cover"
                  />
                </motion.div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Clients Section */}
      <section className="py-12 md:py-12 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#1E293B' }}>
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-10"
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">Our Trusted Clients</h2>
            <div className="w-20 h-1 mx-auto" style={{ backgroundColor: '#FF9800' }}></div>
          </motion.div>

          {/* Client Logos Grid */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={stagger}
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6"
          >
            {sampleClients.map((client, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                whileHover={{ scale: 1.08 }}
                className="flex items-center justify-center p-6 rounded-xl"
                style={{ backgroundColor: '#FFFFFF' }}
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="w-full h-16 md:h-20 object-contain"
                  loading="lazy"
                />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Leadership Team Section */}
      {/* <Leaders/> */}


      {/* CTA Section */}
      <section className="py-12 md:py-12 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="rounded-2xl p-12 md:p-16 shadow-xl text-center"
            style={{ backgroundColor: '#1E293B' }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Ready to Partner With Us?
            </h2>
            <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto text-center" style={{ color: '#CBD5E1' }}>
              Join our growing network of industry-leading companies who have chosen to work with us for their success.
            </p>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="font-bold py-4 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 mx-auto text-lg"
              style={{ backgroundColor: '#FF9800', color: '#1E293B' }}
            >
              <Link to="/contact"> Become a Partner</Link>

              <ArrowRight size={20} />
            </motion.button>
          </motion.div>
        </div>
      </section>



    </div>
  );
};

export default AboutUs;